// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2g4wd","withTopPadding":"_1bXPv","bottomChildren":"_3e-X3","footerbuttons":"_1yqhr"};